import React from 'react';
import { Scissors } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-neutral-800 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_groom-station-1/artifacts/qi23svjr_IMG_0898.jpeg"
                alt="Velvet Cuts"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 max-w-md">
              Modern precíziós ápolás a kortárs férfiak számára. Technikai kiválóság találkozik a minimalista dizájnnal.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Gyors linkek</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors">
                  Szolgáltatások
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-gray-400 hover:text-white transition-colors">
                  Galéria
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-gray-400 hover:text-white transition-colors">
                  Vélemények
                </a>
              </li>
              <li>
                <a href="#booking" className="text-gray-400 hover:text-white transition-colors">
                  Időpontfoglalás
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Elérhetőség</h4>
            <ul className="space-y-2 text-gray-400">
              <li>{contactInfo.phone}</li>
              <li>{contactInfo.email}</li>
              <li className="text-sm">
                {contactInfo.address}<br />
                {contactInfo.city}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} Velvet Cuts. Minden jog fenntartva.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-gray-500 hover:text-white transition-colors">
              Adatvédelmi szabályzat
            </a>
            <a href="#" className="text-gray-500 hover:text-white transition-colors">
              Felhasználási feltételek
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
